import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useKarsilastirma, KARSILASTIRMA_SINIRI } from "../data/karsilastirma";
import { urunleriYukle } from "../data/katalog";

/** Karşılaştırma listesinde ürün varken ekranın altında duran çubuk (karşılaştırma sayfasında gizli). */
export default function KarsilastirmaCubugu() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { idler, cikar, temizle } = useKarsilastirma();
  const [urunler, setUrunler] = React.useState([]);

  React.useEffect(() => {
    if (idler.length) urunleriYukle().then(setUrunler);
  }, [idler.length]);

  const secilenler = useMemo(() => idler.map((id) => urunler.find((u) => u.id === id)).filter(Boolean), [idler, urunler]);

  if (!idler.length || pathname === "/karsilastir") return null;

  return (
    <div className="yazdir-gizle fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 shadow-[0_-12px_30px_-18px_rgba(0,0,0,0.3)] backdrop-blur">
      <div className="container-page flex items-center gap-3 py-3 pe-24">
        <p className="hidden shrink-0 text-[13px] font-semibold text-ink sm:block">
          {t("compare.barTitle")} <span className="font-normal text-muted">({idler.length}/{KARSILASTIRMA_SINIRI})</span>
        </p>
        <ul className="scrollbar-hide flex min-w-0 flex-1 gap-2 overflow-x-auto">
          {secilenler.map((u) => (
            <li key={u.id} className="relative shrink-0">
              <span className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-lg border border-line bg-white" title={u.ad}>
                <img src={u.gorsel} alt={u.ad} className="h-full w-full object-contain p-1" />
              </span>
              <button
                type="button"
                onClick={() => cikar(u.id)}
                aria-label={t("compare.remove")}
                className="absolute -end-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-ink text-[11px] leading-none text-white"
              >
                ×
              </button>
            </li>
          ))}
        </ul>
        <button type="button" onClick={temizle} className="shrink-0 text-[12.5px] text-muted hover:text-accent">
          {t("compare.clear")}
        </button>
        <Link
          to="/karsilastir"
          className={`shrink-0 rounded-md px-4 py-2.5 text-[13.5px] font-semibold transition-colors ${
            idler.length >= 2 ? "bg-ink text-white hover:opacity-90" : "pointer-events-none bg-canvas text-muted"
          }`}
          aria-disabled={idler.length < 2}
        >
          {idler.length >= 2 ? t("compare.go", { count: idler.length }) : t("compare.needTwo")}
        </Link>
      </div>
    </div>
  );
}
